import { request } from '@/utils/request';
import type { RequestOptionsInit } from 'umi-request';

// FIX: https://github.com/ant-design/ant-design/issues/2423
export const baseUploadSingleFile = async ({
  url,
  params,
  options,
}: {
  url: string;
  params: Object;
  options?: RequestOptionsInit;
}): Promise<any> => {
  const formData = new FormData();
  
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return await request(url, {
    method: 'POST',
    data: formData,
    ...options,
  });
};
